<div class="navbar-div">
    <div class="navbar-div" fxHide.xs fxHide.sm fxHide.lt-md>
        <app-web-navbar></app-web-navbar>
    </div>

    <div class="mobile-navbar" fxHide.lg fxHide.md fxHide.lt fxHide.gt-lg>
        <app-sidebar></app-sidebar>
    </div>
</div>
<div class="web-container">
    <div class="bg-black">
        <div class="top-container">
            <div class="text-container">
                <p class="main-header">{{section1Content?.title}}</p>
                <p class="sub-header">{{section1Content?.sub_title}}</p>
                <p class="mt-5"><button class="btn all-access-btn btn-lg fw-bold" *ngIf="!isAllSubscribed"
                        ng-click="openPaymentModal('buyTks', 'all-access-pass')"
                        (click)="openPaymentFlow('buyTks', 'all-access-pass','SUBSCRIPTION_ALL')">Buy Pass</button></p>
                <p class="mt-5"><button class="btn all-access-btn btn-lg fw-bold"
                        [routerLink]="['/cinejoy/passholders-watchlist']" *ngIf="isAllSubscribed">Watchlist</button></p>
            </div>
            <div class="movie-roll-container">
                <img src="../../../../assets/images/all-access-pass/movie-group.png" alt="Movie Roll"
                    class="movie-roll-image" />
            </div>
        </div>
        <div class="mt-3">
            <div class="dashed-block"></div>
            <div class="img-container">
                <img [src]="item?.imageUrl" *ngFor="let item of section1Images">
            </div>
            <div class="dashed-block"></div>
        </div>
    </div>
    <div fxLayout='column' *ngIf="section2?.length"
        class="flex align-items-center justify-content-center gap-3 mb-2 section-2 mt-5 grid-container">
        <div class="text-center mb-1 ">
            <p class="fw-bold sec-2-header">All-Access Pass Perks</p>
            <p class="sub-header-sec-2">${{allAccessEvent?.subscriptionAmount / 100}}/Pass </p>
        </div>
        <div fxLayout="row" fxLayout.xs='column' class="gap-3" fxLayoutGap="70px"
            class="flex align-items-center justify-content-center  gap-3">
            <div fxFlex="24" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
                <div class="image-container">
                    <img [src]="section2[0]?.imageUrl">
                </div>
                <div>
                    <h4 class="content-description">{{section2[0]?.title}}</h4>

                </div>
            </div>
            <div fxFlex="24" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
                <div class="image-container"> <img [src]="section2[1]?.imageUrl"></div>
                <div>
                    <h4 class="content-description">{{section2[1]?.title}}</h4>
                </div>
            </div>
            <div fxFlex="24" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
                <div class="image-container"><img [src]="section2[2]?.imageUrl"></div>
                <div>
                    <h4 class="content-description">{{section2[2]?.title}}</h4>
                </div>
            </div>

        </div>
        <div fxLayout="row" fxLayout.xs='column' fxLayoutGap="70px"
            class="flex align-items-center justify-content-center  gap-3 mt-3">
            <div fxFlex="24" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
                <div class="image-container"><img [src]="section2[3]?.imageUrl"></div>
                <div>
                    <h4 class="content-description">{{section2[3]?.title}}</h4>
                </div>
            </div>
            <div fxFlex="24" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
                <div class="image-container"><img [src]="section2[4]?.imageUrl"></div>
                <div>
                    <h4 class="content-description">{{section2[4]?.title}}</h4>
                </div>
            </div>
            <div fxFlex="24" fxFlex.sm="21" class="flex align-items-center justify-content-center sub-cards">
                <div class="image-container"><img [src]="section2[5]?.imageUrl"></div>
                <div>
                    <h4 class="content-description">{{section2[5]?.title}}</h4>
                </div>
            </div>
        </div>
    </div>

    <div class="section-3">
        <div class="con-1">
            <p class="fw-bold sec-2-header mt-4">{{section3?.title}}</p>
            <div class="left-container">
                <div>
                    <button class="btn all-access-btn btn-lg fw-bold" *ngIf="!isAllSubscribed"
                        (click)="openPaymentFlow('buyTks', 'all-access-pass','SUBSCRIPTION_ALL')">Buy Pass</button>
                    <button class="btn all-access-btn btn-lg fw-bold" [routerLink]="['/cinejoy/passholders-watchlist']"
                        *ngIf="isAllSubscribed">Watchlist</button>
                    <p style="font-size: 18px;margin-top: 20px;">One time purshace of
                        ${{allAccessEvent?.subscriptionAmount / 100}}
                    </p>
                </div>
                <img src="../../../../assets/images/all-access-pass/movie-pop.png">
            </div>
        </div>
        <div class="con-2">
            <div class="banner-container">
                <!-- CineJoy background -->
                <img src="../../../../assets/images/all-access-pass/cinejoy-banner.png" alt="CineJoy Banner"
                    class="background-image">

                <!-- Badge overlay -->
                <img src="../../../../assets/images/all-access-pass/badge.png" alt="Badge" class="badge-image">
            </div>
        </div>

    </div>
</div>

<div class="mobile-container">
    <div class="bg-black">
        <div class="top-container">
            <div class="text-container">
                <p class="main-header">{{section1Content?.title}}</p>
                <p class="sub-header">{{section1Content?.sub_title}}</p>
                <p><button class="btn all-access-btn btn-lg fw-bold" *ngIf="!isAllSubscribed"
                        (click)="openPaymentFlow('buyTks', 'all-access-pass','SUBSCRIPTION_ALL')">Buy Pass</button></p>
                <p><button class="btn all-access-btn btn-lg fw-bold" *ngIf="isAllSubscribed"
                        [routerLink]="['/cinejoy/passholders-watchlist']">Watchlist</button></p>
            </div>
            <div class="movie-roll-container">
                <img src="../../../../assets/images/all-access-pass/movie-group.png" alt="Movie Roll"
                    class="movie-roll-image" />
            </div>
        </div>
        <div class="mt-3">
            <div class="dashed-block"></div>
            <div class="img-container">
                <img [src]="item?.imageUrl" *ngFor="let item of section1Images">
            </div>
            <div class="dashed-block"></div>
        </div>
    </div>
    <div class="mt-2" *ngIf="reloadCarousel">
        <div class="text-center mb-1 ">
            <h2 class="fw-bold sec-2-header-mobile">Pass Perks</h2>
            <p class="sub-header-sec-2">${{allAccessEvent?.subscriptionAmount / 100}}/Pass </p>
        </div>
        <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let slide of section2">
                <ng-template carouselSlide [id]="slide.id">
                    <div class="carousel-container">
                        <img [src]="slide.imageUrl" [alt]="" [title]="">
                        <div class="names">
                            <span>{{slide.title}}</span>
                        </div>
                    </div>

                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>

    <div class="section-3">
        <p class="fw-bold sec-3-header">{{section3?.title}}</p>
        <div class="sec-3-container">
            <div class="con-1">
                <div class="left-container">
                    <img src="../../../../assets/images/all-access-pass/movie-pop.png">

                    <div>
                        <p class="mt-5"><button class="btn all-access-btn btn-lg fw-bold" *ngIf="!isAllSubscribed"
                                ng-click="openPaymentModal('buyTks', 'all-access-pass')"
                                (click)="openPaymentFlow('buyTks', 'all-access-pass','SUBSCRIPTION_ALL')">Buy
                                Pass</button></p>
                        <p class="mt-5"><button class="btn all-access-btn btn-lg fw-bold" *ngIf="isAllSubscribed"
                                [routerLink]="['/cinejoy/passholders-watchlist']">Watchlist</button></p>
                        <p>One time purshace of ${{allAccessEvent?.subscriptionAmount / 100}}/ Pass</p>
                    </div>
                </div>
            </div>
            <div class="con-2">
                <div class="banner-container">
                    <!-- CineJoy background -->
                    <img src="../../../../assets/images/all-access-pass/cinejoy-banner.png" alt="CineJoy Banner"
                        class="background-image">

                    <!-- Badge overlay -->
                    <img src="../../../../assets/images/all-access-pass/badge.png" alt="Badge" class="badge-image">
                </div>
            </div>

        </div>

    </div>
</div>

<div class="footer-div" fxHide.xs fxHide.sm fxHide.lt-md>
    <app-cinejoy-footer></app-cinejoy-footer>
</div>

<div class="footer-div" fxHide.lg fxHide.md fxHide.lt fxHide.gt-lg>
    <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
</div>